// React binding for the ported AxonMultiBarChatState (axon-modal-chat-kit).
// One chat-state instance per mount, subscribed via useSyncExternalStore so
// per-token streaming snapshots flow into React without tearing.

import { useMemo, useSyncExternalStore } from "react";
import { StreamingClient } from "axon-provider-kit/client";
import {
  AxonMultiBarChatState,
  type AxonChatStateSnapshot,
} from "axon-modal-chat-kit/axon-adapter";
import { proxyTransport } from "../services/proxyTransport";

export interface UseAxonChatState {
  state: AxonMultiBarChatState;
  snapshot: AxonChatStateSnapshot;
}

export function useAxonChatState(): UseAxonChatState {
  const state = useMemo(
    () =>
      new AxonMultiBarChatState({
        streamingClient: new StreamingClient({ transport: proxyTransport }),
      }),
    [],
  );

  const snapshot = useSyncExternalStore(
    (listener) => state.subscribe(listener),
    () => state.getSnapshot(),
  );

  return { state, snapshot };
}
